import { Component, Inject, Input, OnInit } from '@angular/core';
import { ChartDisplayElementModel } from '../../models/chart-display-element.model';
import { APP_BASE_HREF } from '@angular/common';
import { ReportSeriesModel } from '../../models/report-series.model';
import { BlockModel } from '../../../PageBuilder/models/block.model';
import { RichTextEditorDefaultStylesModel } from '../../../Forms/models/rich-text-editor-default-styles.model';
import { ReportsSeriesPreviewService } from '../../services/report-series-preview.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { ActionKeys } from '../../../Forms/enums/keys.enum';
import { RichTextEditorConfigModel } from '../../../Forms/components/RichTextEditorCK/model/rich-text-editor-config.model';
import { annotatableBlockTypes } from '../../../../Common/Reports/models/new-data-processing-workflow-block-types.model';

@Component({
    selector: 'agpr-chart-card',
    templateUrl: './chart-card.component.html',
    styleUrls: ['./chart-card.component.scss'],
    standalone: false
})
export class ChartCardComponent implements OnInit {
    @Input() chart: BlockModel;
    @Input() editing: boolean = false;
    @Input() selected: boolean = false;
    @Input() set dateFormat(format: string) {
        this._dateFormat = format;
        if (this.displayElement) {
            this.dateRangeLabel = this.reportsSeriesService.dateRangeToString(this.displayElement.series, null, format);
        }
    }
    @Input() id: string;
    _dateFormat: string;
    displayElement: ChartDisplayElementModel;
    defaultEditorStyles: RichTextEditorDefaultStylesModel = new RichTextEditorDefaultStylesModel();
    ckEditorConfig: RichTextEditorConfigModel;
    dateRangeLabel: string;
    chartAnnotationEnabled: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;

    constructor (
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public reportsSeriesService: ReportsSeriesPreviewService
    ) { }

    ngOnInit(): void {
        this.displayElement = this.chart?.displayElement as ChartDisplayElementModel;
        if (this.displayElement) {
            this.displayElement.note = this.displayElement.note || '';
        }
        this.dateRangeLabel = this.reportsSeriesService.dateRangeToString(this.displayElement.series, null, this._dateFormat);
        this.chartAnnotationEnabled = annotatableBlockTypes.includes(this.displayElement.series[0].chartType);

        this.ckEditorConfig = new RichTextEditorConfigModel({
            enableInsertImage: false,
            aiReferenceId: ''
        });
    }

    setEditing(val) {
        this.editing = val;
    }

    editVal(val) {
        this.editing = val;
        this.selected = val;
    }

    /**
     * Opens new window and navigates to series source
     *
     * @param series - the data to view the source of
     */
    goToSeriesSource(series: ReportSeriesModel): void {
        const seriesUrl = series.getSeriesUrl();
        if (seriesUrl) {
            window.open(this.appBaseHref + seriesUrl);
        }
    }

    onKeyup(event: KeyboardEvent) {
        if (event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE) {
            this.setEditing(true);
        } else if (event.key === ActionKeys.ESCAPE && this.editing) {
            event.stopImmediatePropagation();
            event.preventDefault();
            this.setEditing(false);
        }
    }

    updateDisplayAnnotation(displayAnnotation: boolean): void {
        this.displayElement.displayAnnotationInExport = displayAnnotation;
    }
}
